import * as React from 'react';
import { H3 } from '@ui-library/typography';

interface IStepProps {
  title?: string;
  children: React.ReactNode;
}

const Step = ({ title, children }: IStepProps) => (
  <div>
    {title && <H3 className="text-center p-t-lg">{title}</H3>}
    {children}
  </div>
);

export default Step;
